import React from 'react'
import '@/sass/project.scss';
import MProject from './model/Project'
import Card from 'components/layouts/Card';
import { Projects, LEMONHEXA, PATHLAB, CEOUS, INVITEMAN } from 'components/constant/Project';
import { Technologies } from 'components/constant/Technology';


interface IState {
    selectedProject: MProject,
    projects: string[],
    selectedImage: number,
}

class Project extends React.Component<{}, IState> {
    constructor(props: {}) {
        super(props)
        this.state = {
            projects: [
                LEMONHEXA,
                CEOUS,
                PATHLAB,
                INVITEMAN
            ],
            selectedProject: new MProject([], "", "", []),
            selectedImage: 0
        }
    }

    showProject(key: string) {
        this.setState({
            selectedProject: Projects[key],
            selectedImage: 0
        })
    }

    showImage(index: number) {
        this.setState({
            selectedImage: index
        })
    }

    render() {
        const idx = this.state.selectedImage
        let currentImage;
        const images = this.state.selectedProject.getImage()
        if (images.length > 0) {
            currentImage = images[idx].getSource()
        }
        return (
            <div id="project" className="project">
                <div className="container">
                    <div className="row justify-content-center">
                        <h2 className="header col-12">Project</h2>
                        <div className="projects content-container row">
                            {
                                this.state.projects.map(x => {
                                    const prjct = Projects[x]
                                    return (
                                        <div className="col-md-4 col-lg-3 project" key={x} onClick={() => this.showProject(x)} data-toggle="modal" data-target="#project-modal">
                                            <Card image={prjct.getImage()[0].getSource()} imageName={prjct.getName()}/>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="project-modal" tabIndex={-1} role="dialog" aria-labelledby="project-title" aria-hidden="true">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <div className="view-container">
                                            <div className="project-views">
                                                <div className="project-view">
                                                    <div className="image-view">
                                                        <img src={currentImage} alt={this.state.selectedProject.getName()} />
                                                    </div>
                                                </div>
                                                <div className="views">
                                                    <div className="card-container">
                                                        {images.map((x, i) => {
                                                            const view = {
                                                                backgroundImage: `url(${x.getSource()})`
                                                            }
                                                            return (
                                                                <div className="view" 
                                                                    key={`${this.state.selectedProject.getName()}_${i}`}
                                                                    style={view}
                                                                    onClick={()=> this.showImage(i)} />
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-7">
                                        <h3 className="project-title">{this.state.selectedProject.getName()}</h3>
                                        <div className="project-description">
                                            {this.state.selectedProject.getDescription()}
                                        </div>
                                        <div className="tools">
                                            <label>What I used to build:</label>
                                            <div className="tools-container d-flex">
                                                <div className="card-container">
                                                    {this.state.selectedProject.getTechnologies().map((x) => {
                                                        const tech = Technologies[x]
                                                        return <Card key={x} 
                                                            image={tech.getImage().getSource()} 
                                                            imageName={tech.getName()} 
                                                            content={tech.getName()} />
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Project